<div class="google-map">
    <google-map
        mapId="shift-settings-map"
        height="100%"
        width="100%"
        [center]="center()"
        [zoom]="zoom()"
        [options]="mapOptions"
        (tilesloaded)="onMapReady()">
        @if (mapRadius() && center()) {
            <map-circle [center]="center()" [radius]="mapRadius()" [options]="circleOptions" />
        }
        @if (center()) {
            <map-advanced-marker [position]="center()" [options]="markerOptions" />
        }
    </google-map>

    @if (showCurrentLocationButton && mapLoaded()) {
        <c-button
            class="google-map__current-location-btn"
            [type]="currentLocationActive ? 'primary' : 'secondary'"
            [iconOnly]="true"
            [icon]="currentLocationIcon"
            (action)="currentLocationRequested.emit()" />
    }
</div>
